import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../css/Usuarios.css";
import Menu from "./components/Menu";
import { dB64 } from "../shared/Encriptacion";
import axios from "axios";
import { HEADERS_API } from "./NuevaGuia";
import { ValidarSesion } from "../shared/Validaciones";
import {ValidarNumLtr} from "../shared/Regex";

export default function Usuarios(){
    // ======================================================================================================
    //#region HOOKS STATE
    // ======================================================================================================

    // ESTADOS DE CONTENIDO
    const[modalAgregar, setModalAgregar] = useState("");
    const[selectRol, setSelectRol] = useState(<></>);
    const[listaUsuarios, setListaUsuarios] = useState([]);


    // ESTADOS DE FILTRO
    const[filtroUsuario, setFiltroUsuario] = useState("");
    const[filtroRol, setFiltroRol] = useState(0);
    const[filtroEstado, setFiltroEstado] = useState("-");

    //#endregion

    // ======================================================================================================
    //#region HOOKS EFFECT
    // ======================================================================================================
    useEffect(()=>{
        ValidarSesion();
        ObtenerRolesUsuario();
        ObtenerListaUsuarios(filtroUsuario, filtroRol, filtroEstado);
    },[]);
    //#endregion

    // ======================================================================================================
    //#region HANDLERS
    // ======================================================================================================

    // ESTADOS DE CONTENIDO
    const HandlerModalAgregar = (valor) => {
        setModalAgregar(valor);
    } 
    const HandlerSelectRol = (lista) => {
        const listaRoles = [
            { id: "0", descripcion: "Seleccionar" },
            ...lista.map(rol => ({ id: rol.id, descripcion: rol.descripcion }))
        ];

        const listaOpciones = listaRoles.map(item => (
            <option key={item.id} value={item.id} className="text-capitalize">
                {item.descripcion.toLowerCase()}
            </option>
        ));

        setSelectRol(listaOpciones);
    }
    const HandlerListaUsuarios = (lista) => {
        setListaUsuarios(lista);
    }

    // ESTADOS DE FILTRO
    const HandlerFiltroUsuario = (valor) => {
        if(ValidarNumLtr(valor) || valor == ""){
            setFiltroUsuario(valor);
        }
    }
    const HandlerFiltroRol = (valor) => {
        setFiltroRol(valor);
    }
    const HandlerFiltroEstado = (valor) => {
        setFiltroEstado(valor);
    }

    //#endregion

    // ======================================================================================================
    //#region FUNCIONES
    // ======================================================================================================
    // FUNCIONES ASÍNCRONAS
    const ObtenerRolesUsuario = async () => {
        try{
            let response = await axios.get(URL_ROLES_USUARIO,{
                headers: HEADERS_API
            }).catch(error => {
                throw new Error(error.message);
            });

            HandlerSelectRol(response.data.lista);
            HandlerFiltroRol(0);
        }catch(error){
            console.log(error);
        }
    }
    async function ObtenerListaUsuarios(usuario, rol, estado){
        const paramUsuario = usuario == "" ? "-" : usuario;
        try{
            let response = await axios.get(URL_LISTAR_USUARIOS, {
                headers: HEADERS_API,
                params: {
                    fUsuario: paramUsuario,
                    fRol: rol,
                    fEstado: estado
                }
            }).catch(error => {
                throw new Error(error.message);
            });

            HandlerListaUsuarios(response.data.lista);
        }catch(error){
            console.log(error);
        }
    }

    // FUNCIONES COMPLEMENTARIAS
    async function QuitarFiltrosBusquedaUsuario(){
        HandlerFiltroEstado("-");
        HandlerFiltroUsuario("");
        HandlerFiltroRol(0);
        ObtenerListaUsuarios("", 0, "-");
    }
    //#endregion

    // ======================================================================================================
    //#region CONTENIDO
    // ======================================================================================================
    return(<>
    <Menu/>
    <div className="container">
        <div className="row">
            <div className="col-12 py-2 border-bottom border-secondary text-secondary text-center text-md-start">
                <h2>{dB64(localStorage.getItem('r6'))}</h2>
            </div>
            <div className="col-12 py-3 text-center">
                <h2>USUARIOS</h2>
            </div>
            <div className="col-12 py-1">
                <Link to={"/nuevo-usuario"}>
                    <button className="btn btn-primary">Nuevo Usuario</button>
                </Link>
            </div>

            {/* FILTROS */}
            <div className="col-12 col-md-5 px-1 py-2">
                <div className="form-floating">
                    <input onChange={e=>HandlerFiltroUsuario(e.target.value)} value={filtroUsuario} maxLength={50} type="text" className="form-control" placeholder="Usuario" id="filtro-usuario" autoComplete="off"/>
                    <label htmlFor="filtro-usuario">Usuario</label>
                </div>
            </div>
            <div className="col-12 col-md-2 px-1 py-2">
                <div className="form-floating">
                    <select onChange={e=>HandlerFiltroRol(e.target.value)} value={filtroRol} className="form-select text-capitalize" id="filtro-rol" placeholder="Rol">
                        {selectRol}
                    </select>
                    <label htmlFor="filtro-rol">Perfil</label>
                </div>
            </div>
            <div className="col-12 col-md-2 px-1 py-2">
                <div className="form-floating">
                    <select onChange={e=>HandlerFiltroEstado(e.target.value)} value={filtroEstado} className="form-select" id="filtro-estado" placeholder="Estado">
                        <option value="-">Seleccionar</option>
                        <option value="activo">Activo</option>
                        <option value="inactivo">Inactivo</option>
                    </select>
                    <label htmlFor="filtro-estado">Estado</label>
                </div>
            </div>
            <div className="col-12 col-md-3 d-flex justify-content-around align-items-center">
                <button onClick={e=>ObtenerListaUsuarios(filtroUsuario, filtroRol, filtroEstado)} className="btn btn-primary">Filtrar</button>
                <button onClick={QuitarFiltrosBusquedaUsuario} className="btn btn-secondary">Quitar filtros</button>
            </div>
            <div className="contenedor-tabla py-2">
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th scope="col">N°</th>
                            <th scope="col">Código</th>
                            <th scope="col">Nombres y Apellidos</th>
                            <th scope="col">Perfil</th>
                            <th scope="col">Estado</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                        listaUsuarios.length > 0 ? listaUsuarios.map((item, index) => (
                        <tr key={item.id}>
                            <td>{index+1}</td>
                            <td>{item.codigo}</td>
                            <td>{item.nombre}</td>
                            <td>{item.rol}</td>
                            {
                                item.estado == "activo" ? (<td className="text-success fw-semibold">Activo</td>) : (<td className="text-danger fw-semibold">Inactivo</td>)
                            }
                            <td>
                                <Link to={`/detalle-usuario/${item.codigo}`} className="btn btn-primary">
                                Detalles
                                </Link>
                            </td>
                        </tr>
                        )) : (
                            <tr>
                                <td colSpan={6} className="text-secondary text-center fs-4 fw-semibold">Sin resultados</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    </>)

    //#endregion
}

// ======================================================================================================
//#region CONSTANTES
// ======================================================================================================
const URL_ROLES_USUARIO = process.env.REACT_APP_URL_ROLES_USUARIO;
const URL_LISTAR_USUARIOS = process.env.REACT_APP_URL_LISTAR_USUARIOS;
//#endregion